import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./styles.css";

const QUienEsomponent = (props) => {
  return (
    <Fragment>
      <div className="overlay-quiene-es">
        <div>
          <p></p>
          <span>
            {props.cambiarIdioma
              ? "< Estamos muy cerca de ti… >"
              : "< We are close to you >"}
          </span>
          <p>
            {props.cambiarIdioma
              ? "< Nuestro origen lo cambió todo. Observamos tu primera conexión, Tu primer streaming, tu primer llamado, y por supuesto, tu primera producción. >"
              : "< Our origin changed everything. We were there when you installed your first router. Your first streaming, your first call, and of course, your first production. >"}
          </p>
          <p>
            {props.cambiarIdioma
              ? "< Estuvimos siempre contigo, porque nosotros somos la tecnología. Somos la experiencia, el conocimiento y la transformación. Somos una nueva forma de ver las cosas. Somos una multitud con una misma meta. >"
              : "< We were always there with you, because we are technology. We are the experience of a long journey. We are the knowledge. We are the transformation. We are a new way of seeing things. We are a crowd with a common goal. >"}
          </p>
          <p>
            {props.cambiarIdioma
              ? "< Hacemos lo que otros no se atreven a hacer: queremos volverte omnipresente, darte el poder de ver los detalles y entregarte más control sobre tus producciones. >"
              : "< We make what others don’t dare: we want to make you omnipresent, give you the power of seeing every detail and deliver you total control over your productions. >"}
          </p>
          <p>
            {props.cambiarIdioma
              ? "< Bienvenidos a un paso más allá en el universo audiovisual. >"
              : "< Welcome to a step beyond in the audiovisual universe. >"}
          </p>
          <p>{props.cambiarIdioma ? "< Somos Jack. >" : "< We are Jack >"}</p>
          <p></p>
        </div>
      </div>
      <div className="quien-es-fondo"></div>
    </Fragment>
  );
};

QUienEsomponent.propTypes = {
  cambiarIdioma: PropTypes.bool,
};

export default QUienEsomponent;
